import produce, { Draft } from 'immer'

import {
  UPDATE_BATCH_ALIAS_ASSIGNMENTS,
  SET_BATCH_PRODUCT_ALIASES,
  SET_PRODUCT_ALIASES,
  UPDATE_PRODUCT_ALIASES,
  SET_BATCH_ALIAS_ASSIGNMENTS_IS_CONFIRM,
  SET_BATCH_ALIAS_ASSIGNMENTS_IS_IGNORED,
  DELETE_BATCH_ALIAS_ASSIGNMENTS,
  UPDATE_BATCH_ALIAS_ASSIGNMENT_WORKSTREAM_TAGS,
} from '../actions/productAliases'
import { Alias, ProductAliasesActionTypes, ProductAliasesState } from '../types/productAliases'

const aliasesByIdParser = (aliases: Alias[]) => {
  const aliasesById: { [key: number]: string[] } = {}
  aliases.forEach((alias: Alias) => {
    aliasesById[alias.product_id] = alias.names.map((name) => name.trim())
  })

  return aliasesById
}

const initialState: ProductAliasesState = {
  aliasesById: {},
  batchAliasesById: {},
  batchAliasAssignments: {},
}

const initialBatchAliasAssignment = () => {
  return {
    workstreamTags: { needsTlc: false, fixCategory: false, noMatch: false },
  } as const
}

export const productAliasesReducer = produce(
  (state: Draft<ProductAliasesState>, action: ProductAliasesActionTypes) => {
    switch (action.type) {
      case SET_PRODUCT_ALIASES:
        if (action.payload.batchId) {
          state.aliasesById = state.batchAliasesById[action.payload.batchId] || {}
        } else {
          state.aliasesById = aliasesByIdParser(action.payload.aliases)
        }
        return

      case SET_BATCH_PRODUCT_ALIASES:
        if (action.payload !== null) {
          state.batchAliasesById[action.payload.batchId] = aliasesByIdParser(action.payload.aliases)
        } else {
          state.batchAliasesById = {}
        }

        return

      case UPDATE_PRODUCT_ALIASES:
        const { product_id, name } = action.payload.alias
        const aliases = state.aliasesById[product_id]
          ? [...state.aliasesById[product_id], name]
          : [name]
        state.aliasesById[product_id] = aliases
        return

      case UPDATE_BATCH_ALIAS_ASSIGNMENTS:
        if (action.payload !== null) {
          state.batchAliasAssignments[action.payload.batchId] = {
            batchSelectedProduct: {
              ...action.payload.batchSelectedProduct,
              photos: action.payload.batchSelectedProductPhotos,
              aliases: action.payload.batchSelectedProductAliases,
              removal_status: action.payload.batchSelectedProduct.attributes.removal_status,
              request_uuid: action.payload.batchSelectedProduct.attributes.request_uuid,
            },
            isConfirmed: action.payload.isConfirmed,
            workstreamTags:
              state.batchAliasAssignments[action.payload.batchId]?.workstreamTags ||
              initialBatchAliasAssignment().workstreamTags,
          }
        } else {
          state.batchAliasAssignments = {}
        }
        return

      case SET_BATCH_ALIAS_ASSIGNMENTS_IS_CONFIRM:
        if (state.batchAliasAssignments[action.payload.batchId]) {
          state.batchAliasAssignments[action.payload.batchId].isConfirmed =
            action.payload.isConfirmed
        }
        return

      case SET_BATCH_ALIAS_ASSIGNMENTS_IS_IGNORED:
        if (state.batchAliasAssignments[action.payload.batchId] === undefined) {
          state.batchAliasAssignments[action.payload.batchId] = initialBatchAliasAssignment()
        }
        state.batchAliasAssignments[action.payload.batchId].isIgnored = action.payload.isIgnored

        return

      case DELETE_BATCH_ALIAS_ASSIGNMENTS:
        if (state.batchAliasAssignments[action.payload.batchId]) {
          delete state.batchAliasAssignments[action.payload.batchId]
        }
        return

      case UPDATE_BATCH_ALIAS_ASSIGNMENT_WORKSTREAM_TAGS:
        const { batchId, workstreamTags } = action.payload
        if (state.batchAliasAssignments[batchId] === undefined) {
          state.batchAliasAssignments[batchId] = initialBatchAliasAssignment()
        }
        const oldTags = state.batchAliasAssignments[batchId].workstreamTags
        state.batchAliasAssignments[batchId].workstreamTags = { ...oldTags, ...workstreamTags }

        return
    }
  },
  initialState
)
